module.exports = {
	"users": [
		{
			"id": 12345,
			"login": "anna",
			"password": ""
		},
		{
			"id": 12346,
			"login": "mike",
			"password": ""
		},
		{
			"id": 12347,
			"login": "mason",
			"password": ""
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./src/www/resources/users.json
 ** module id = 620
 ** module chunks = 0
 **/